<template>
  <div id="apoio">
    <!-- <div class="telefone">Suporte: (11) 5643-5408</div> -->
    <div class="wrapper">
      <!-- ############################################### -->
      <!-- ### MENU MOBILE : VISÍVEL EM TELAS PEQUENAS ### -->
      <!-- ############################################### -->
      <div id="menu-mobile">
        <!-- <div @click="showDownloadModal('cadastro')" class="button-body">
          <div class="icon">
            <img src="@/assets/icon_exe_cadastro.png" alt="" />
          </div>
          <div class="label">Cadastro</div>
        </div>

        <div @click="showDownloadModal('coordenador')" class="button-body">
          <div class="icon">
            <img src="@/assets/icon_exe_coord.png" alt="" />
          </div>
          <div class="label">Coordenador</div>
        </div> -->

        <div @click="showDownloadModal('leitora')" class="button-body">
          <div class="icon">
            <img src="@/assets/icon_exe_leitora.png" alt="" />
          </div>
          <div class="label">Leitora SiaaE</div>
        </div>
      </div>

      <!-- ##################################################### -->
      <!-- ### MENU WIDE : VISÍVEL EM TELAS MÉDIAS E GRANDES ### -->
      <!-- ##################################################### -->
      <div id="menu-wide">
        <!-- <div class="icon-body" @click="showDownloadModal('cadastro')">
          <div class="icon">
            <img src="@/assets/icon_exe_cadastro.png" alt="" />
          </div>
          <div class="label">Cadastro</div>
        </div>

        <div class="icon-body" @click="showDownloadModal('coordenador')">
          <div class="icon">
            <img src="@/assets/icon_exe_coord.png" alt="" />
          </div>
          <div class="label">Coordenador</div>
        </div> -->

        <div class="icon-body" @click="showDownloadModal('leitora')">
          <div class="icon">
            <img src="@/assets/icon_exe_leitora.png" alt="" />
          </div>
          <div class="label">Leitora SiaaE</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "Apoio",
  methods: {
    ...mapMutations(["showDownloadModal"]),
  },
};
</script>

<style lang="scss" scoped>
#apoio {
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;
  align-content: stretch;
  justify-content: center;
  flex: 1 1 auto;
  background-color: white;

  .telefone {
    display: block;
    width: 100%;
    flex: 0 0 auto;
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    padding: 8px;
    box-sizing: border-box;
    background-color: #991f43;
    color: white;
  }

  .wrapper {
    display: flex;
    flex-flow: row nowrap;
    align-items: stretch;
    align-content: stretch;
    justify-content: center;
    flex: 1 1 auto;
  }

  #menu-mobile {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    align-content: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 100%;
    box-sizing: border-box;
    padding: 16px 32px;

    .button-body {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      align-content: center;
      justify-content: flex-start;
      flex: 0 0 auto;
      text-decoration: none;
      border: none;
      outline: none;
      text-decoration: none;
      border-radius: 6px;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
      cursor: pointer;
      background-color: #607594;
      height: 72px;
      margin: 16px 0px;
      width: 100%;
      color: white;
      font-size: 18px;
      font-weight: 500;
      transition: all 0.2s ease-in-out;

      &:hover {
        background-color: #4d5f7a;
      }

      .icon {
        display: block;
        flex: 0 0 auto;
        width: 54px;
        height: 54px;
        margin: 0px 16px;
        border-radius: 6px;
        overflow: hidden;

        img {
          width: 54px;
          height: 54px;
        }
      }
    }
  }

  #menu-wide {
    display: none;
    flex-flow: row nowrap;
    align-items: center;
    align-content: center;
    justify-content: space-around;
    flex: 0 0 auto;
    width: 100%;
    max-width: 920px;

    .icon-body {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      align-content: center;
      justify-content: center;
      flex: 0 0 auto;
      text-decoration: none;
      border: none;
      outline: none;
      text-decoration: none;
      cursor: pointer;

      .icon {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        align-content: center;
        justify-content: center;
        width: 200px;
        height: 200px;
        border-radius: 20px;
        transition: all 0.2s ease-in-out;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
        background-color: #fff;
        margin: 5px;
        box-sizing: border-box;
        overflow: hidden;

        img {
          display: block;
          width: 100%;
          transition: inherit;
        }
      }

      .label {
        display: block;
        text-align: center;
        font-size: 24px;
        font-weight: 500;
        margin-top: 16px;
        color: #2c2c2c;
        transition: color 0.2s ease-in-out;
      }

      &:hover {
        .icon {
          box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3),
            0 15px 12px rgba(0, 0, 0, 0.22);
          width: 210px;
          height: 210px;
          margin: 0px;
        }

        .label {
          color: #607594;
        }
      }
    }
  }
}

@media only screen and (min-width: 670px) {
  #apoio {
    #menu-mobile {
      display: none;
    }

    #menu-wide {
      display: flex;
    }
  }
}

@media only screen and (min-width: 380px) {
  #apoio {
    #menu-mobile {
      .button-body {
        font-size: 26px;
      }
    }
  }
}
</style>
